import './CompareText.scss';
import { Loader } from '@creditsights/styleguide-web';
import React, { ReactElement, useEffect, useRef, useState, useTransition } from 'react';
import DiffMatchPatch from 'diff-match-patch';
import useOnScreen from '../../hooks/viewport/useOnScreen';

const diffMatchPatch = new DiffMatchPatch();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function CompareText({ text1, text2, expanded }): ReactElement {
  const ref = useRef<any>();
  const isVisible = useOnScreen(ref);
  const [isPending, startTransition] = useTransition();
  const [array, setArray] = useState<any[]>([]);

  useEffect(() => {
    if (isVisible && text1 !== text2) {
      startTransition(() => {
        const diffs = diffMatchPatch.diff_main(text1 || '', text2 || '');
        diffMatchPatch.diff_cleanupEfficiency(diffs);
        setArray(diffs);
      });
    } else {
      setArray([]);
    }
  }, [isVisible, text1, text2]);

  const renderDifferences = () => {
    return array.map((item, index) => {
      const [type, text] = item;
      return (
        // eslint-disable-next-line react/no-array-index-key
        <span key={index} className={`diff-type-${type}`}>
          {text}
        </span>
      );
    });
  };

  return (
    <div className="cs-compare-text-ctx" ref={ref}>
      {isPending && <Loader text="Processing" />}
      {expanded && (
        <span>
          {array.length > 0 && renderDifferences()}
          {array.length === 0 && text2}
        </span>
      )}
    </div>
  );
}

export default CompareText;
